export default "__VITE_ASSET__DOHQ1Gi9__"